// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { css } from "styled-components";

actionStyles.wrapper = {
    ...actionStyles.wrapper,
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    `,
};

actionStyles.overflowMenu = {
    ...actionStyles.overflowMenu,
    cssOverrides: {
        wrapper: css`
            & > button {
                margin-left: -5px;

                &:hover,
                &:active,
                &:focus {
                    margin-left: -5px;
                }
            }
        `,
    },
};

actionStyles.printButton = {
    ...actionStyles.printButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};

actionStyles.scheduleButton = {
    ...actionStyles.scheduleButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};

actionStyles.editButton = {
    ...actionStyles.editButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};

actionStyles.shareButton = {
    ...actionStyles.shareButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};

actionStyles.addItemButton = {
    ...actionStyles.addItemButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};

actionStyles.removeSelectedButton = {
    ...actionStyles.removeSelectedButton,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
        border-width: 1px;
    `,
    variant: "tertiary",
};
